





































import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import { Actions } from '@/util/vuex-types'
import qrcode from 'qrcode'
import Event from '@/models/event'
import RateBreweryForm from '@/components/RateBreweryForm.vue'

@Component({
    components: {
        'rate-brewery-form': RateBreweryForm,
    },
})
export default class HostEvent extends Vue {

    @State currentEvents!: Event[]
    @Action [Actions.FETCH_EVENTS]: any
    loading: boolean = false
    chosenEventCode: string = ''
    imageData: string = ''
    rateBrewery: boolean = false
    event?: Event
    breweryRated = false

    async mounted() {
        if (this.currentEvents == null || this.currentEvents.length === 0) {
            this.loading = true
            await this.fetchEvents(await this.$auth.getAccessToken())
            this.loading = false
        }
    }

    async generateQR() {
        this.rateBrewery = false
        this.event = undefined
        this.breweryRated = false

        if (!this.chosenEventCode) {
            this.imageData = ''
            return
        }
        const foundEvent = this.currentEvents.find((elem) => elem.code === this.chosenEventCode)
        if (foundEvent) {
            this.event = foundEvent
        }

        try {
            const data = await qrcode.toDataURL(this.chosenEventCode)
            this.imageData = data
        } catch (err) {
            console.error(err)
            this.imageData = ''
        }
    }
}
